

export const CDN_URL = "https://img.freepik.com/free-vector/vintage-restaurant-menu_23-2147491098.jpg?w=740&t=st=1714142886~exp=1714143486~hmac=ae7023fc0fbb0c5ff694ec68d6f007d74b762841669595ef211901671b6d1fc4"

export const IMG_URL = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/"

export const Food_URL = "https://www.swiggy.com/dapi/restaurants/list/v5?lat=11.0267396&lng=77.0145662&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING"

export const Menu_URL = "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=11.0267396&lng=77.0145662&restaurantId=";

export const Foot_URL = "https://www.freepik.com/free-ai-image/delicious-looking-3d-burger-with-simple-background_76531657.htm#query=food%20png&position=2&from_view=keyword&track=ais_user&uuid=4ae1008d-4ca4-45a9-b18a-26597be3ffa7"